import store from '@/store/index'

// Both debug features are gated by a single build-time env flag. When
// VUE_APP_ENABLE_PRINT_DEBUG !== 'true', DefinePlugin substitutes the
// literal and the rest of each function body is dropped by terser at
// minify time — no debug logic ships to production builds.

const SIMULATED_ERROR_CODE = 'SIMULATED_PRINTER_ERROR'

// Per-bet counter — printLoto/printSports each bump this on every
// postMessage send. Reset via resetSimulatePrintCounter() at the start
// of each new bet (on-show-reprint) so 'first-then-success' mode
// targets the *first* attempt of every new bet, not the first attempt
// of the session.
let simulateCallCount = 0

const splitList = (raw: string | null | undefined): string[] =>
    (raw || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)

const currentUserId = (): string => {
    const id = (store.state as any).userInfo?.details?.id
    return id != null ? String(id) : ''
}

export const isBypassPrintingUser = (): boolean => {
    if (process.env.VUE_APP_ENABLE_PRINT_DEBUG !== 'true') return false
    const me = currentUserId()
    if (!me) return false
    return splitList((store.state as any).usersBypassPrintingCheck).includes(me)
}

export const shouldSimulatePrintError = (): boolean => {
    if (process.env.VUE_APP_ENABLE_PRINT_DEBUG !== 'true') return false
    const me = currentUserId()
    if (!me) return false
    return splitList((store.state as any).usersSimulatePrintError).includes(me)
}

export const resetSimulatePrintCounter = (): void => {
    if (process.env.VUE_APP_ENABLE_PRINT_DEBUG !== 'true') return
    simulateCallCount = 0
}

// Returns either {} or { simulateError: '<code>' }. Spread into the
// print-by-format postMessage payload so iframe.ts can short-circuit
// the hardware path and emit a deterministic 400.
//
// Modes (printSimulateMode from settings API):
//   'always-error'       — every send returns 400 (default)
//   'first-then-success' — 1st send returns 400, subsequent sends succeed.
//                          Counter resets per bet.
export const buildSimulateErrorField = (): { simulateError?: string } => {
    if (process.env.VUE_APP_ENABLE_PRINT_DEBUG !== 'true') return {}
    if (!shouldSimulatePrintError()) return {}
    const mode = (store.state as any).printSimulateMode || 'always-error'
    simulateCallCount += 1
    if (mode === 'first-then-success' && simulateCallCount > 1) {
        return {}
    }
    return { simulateError: SIMULATED_ERROR_CODE }
}
